import {
    DisplayAdvertisingCampaigns
} from "app/pages/digital-marketing/ad-intelligence/advertisers/campaigns/DisplayAdvertisingCampaigns";
import { IndustryCampaigns } from "app/pages/digital-marketing/ad-intelligence/advertisers/campaigns/IndustryCampaigns";
import {
    DisplayAdvertisingOverviewPage
} from "app/pages/digital-marketing/ad-intelligence/advertisers/overview/DisplayAdvertisingOverviewPage";
import { IndustryOverview } from "app/pages/digital-marketing/ad-intelligence/advertisers/overview/IndustryOverview";
import {
    AdvertisersPublishers
} from "app/pages/digital-marketing/ad-intelligence/common/advertisersPublishers/AdvertisersPublishers";
import {
    IndustryPublishers
} from "app/pages/digital-marketing/ad-intelligence/common/advertisersPublishers/IndustryPublishers";
import {
    createIndustryAwareRoute
} from "app/pages/digital-marketing/ad-intelligence/shared/routes/createIndustryAwareRoute";

const PublishersReport = () => (
    <AdvertisersPublishers
        controller="advertiser"
        resource="publisher"
    />
);

/**
 * Display Advertising reports that serve both domain and industry mode.
 *
 * Every solution mounting these reports must use these components rather than the domain pages
 * directly, otherwise the `industry` URL param is silently ignored and selecting an industry in
 * the asset picker leaves the page unchanged. The matching state declaration also has to allow
 * access without `key` via `AccessWithoutMandatoryParamsHOC(..., ["industry"])`.
 */
export const DisplayAdvertisingOverviewRoute = createIndustryAwareRoute(
    DisplayAdvertisingOverviewPage,
    IndustryOverview,
);

export const DisplayAdvertisingCampaignsRoute = createIndustryAwareRoute(
    DisplayAdvertisingCampaigns,
    IndustryCampaigns,
);

export const DisplayAdvertisingPublishersRoute = createIndustryAwareRoute(PublishersReport, IndustryPublishers);
